<template>
  <div>
    <div class="top-banner"></div>

    <div id="planningDevelopment" class="container join-us">
      <div class="container-title">
        <h3>规划与发展</h3>
        <p>Planning And Development</p>
        <div class="line"></div>
      </div>
      <ul class="job-list">
        <li>
          <p class="colorRed">&nbsp;&nbsp;职业规划</p>
          <div class="job-block1">
            <dl class="job-block-top">
              <div>
                <img class="block-img" src="@/assets/img/join/jin.png" />
              </div>
              <div class="block-text">
                <dt>晋升制度</dt>
                <div class="text-line"></div>
                <dd>双渠道晋升、拓展员工职业发展空间。员工可以根据自己的兴趣和专长自主选择专业化和管理化两种晋升渠道。</dd>
              </div>
            </dl>
            <dl class="job-block-top" style="padding-bottom:30px">
              <div>
                <img class="block-img" src="@/assets/img/join/tiao.png" />
              </div>
              <div class="block-text">
                <dt>调岗制度</dt>
                <div class="text-line"></div>
                <dd>为保证员工能在自己感兴趣的岗位发挥优势，公司提供内部调岗机会，员工可根据个人意愿及岗位胜任力要求，提出转岗意向。</dd>
              </div>
            </dl>
          </div>
        </li>
        <li>
          <p class="colorRed">&nbsp;&nbsp;培训发展</p>
          <div class="job-block2">
            <dl class="job-block-top">
              <div>
                <img class="block-img" src="@/assets/img/join/xin.png" />
              </div>
              <div class="block-text">
                <dt>新员工培训</dt>
                <div class="text-line"></div>
                <dd>介绍公司、企业文化、制度流程等内容，让您快速了解玩咖。</dd>
                <dd>岗位技能培训——帮助您了解部门制度、工作规范等内容，不定期的为员工提供新知识和技术的交流分享。导师辅导——在工作、生活和文化方面给予您更多的经验传递。</dd>
              </div>
            </dl>
            <dl class="job-block-top" style="padding-bottom:30px">
              <div>
                <img class="block-img" src="@/assets/img/join/zhuan.png" />
              </div>
              <div class="block-text">
                <dt>专业技术及管理技能培训</dt>
                <div class="text-line"></div>
                <dd>公司致力于培养适应互联网快速发展的优秀技术人员和管理人才。针对不同培训需求制定了相应的培训计划，让您的职业化程度和专业水平能够得到持续不断的提升。</dd>
              </div>
            </dl>
          </div>
        </li>
      </ul>
    </div>
    <div id="salaryWelfare" class="container join-us">
      <div class="container-title">
        <h3>薪酬福利</h3>
        <p>Salary And Welfare</p>
        <div class="line"></div>
      </div>
      <div class="salary-welfare-text">
        <img src="@/assets/img/join/fuli.png" />
        <p class="img-text">公司采用多元化薪酬福利制度和激励措施，为员工提供丰富多样的综合福利，旨在为员工创建舒适的工作环境，并实现工作生活的平衡。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Join"
};
</script>

<style scoped>
.top-banner {
  width: 100%;
  height: 400px;
  background: url(../../assets/img/join/banner.png) top no-repeat;
  background-size: cover;
}
.job-block-top {
  display: flex;
  padding-top: 30px;
}
.block-img {
  width: 60px;
  height: 60px;
  margin-left: 160px;
  margin-top: 20px;
}
.block-text {
  margin-left: 120px;
  width: 500px;
}
.container {
  box-sizing: border-box;
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 20px;
}
.join-us {
  padding: 60px 80px 80px;
  color: #7d7d7d;
}
.container-title h3 {
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 36px;
  color: #333333;
  font-weight: bold;
}

.container-title p {
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color: #999999;
}

.job-block1 {
  background-color: white;
  margin-top: 10px;
  margin-bottom: 30px;
  background: url(../../assets/img/join/1.png) top no-repeat;
  background-size: cover;
}

.job-block2 {
  background-color: white;
  margin-top: 10px;
  background: url(../../assets/img/join/2.png) top no-repeat;
  background-size: cover;
}

.job-list dt,
.schooljob-list dt {
  line-height: 40px;
  font-size: 18px;
  color: #222;
}

.job-list dd,
.schooljob-list dd {
  line-height: 30px;
  font-size: 13px;
}
.job-list dd {
  white-space: pre-wrap;
}

.salary-welfare-text {
  padding-top: 30px;
  text-align: center;
  /* border-top: 1px solid #eee; */
  padding-bottom: 30px;
  background-color: white;
  position: relative;
}

.img-text {
  position: absolute;
  width: 440px;
  height: 80px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  top: 180px;
  left: 320px;
  line-height: 30px;
}

.line {
  width: 34px;
  height: 5px;
  background: rgba(0, 122, 255, 1);
  margin: 5px auto 40px;
}

.text-line {
  width: 40px;
  height: 3px;
  background: rgba(0, 122, 255, 1);
  margin-bottom: 10px;
}

.colorRed {
  font-size: 14px;
  color: #333333;
  text-align: left;
}

.colorRed::before {
  width: 8px;
  height: 8px;
  background: rgba(199, 199, 199, 1);
  display: inline-block;
  content: "";
}
</style>
